import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { AlertTriangle, Check, X } from 'lucide-react';

export default function ConfirmChangesDialog({ changes, onConfirm, onCancel }) {
  const { t } = useTranslation();
  const changeCount = Object.keys(changes).length;

  return (
    <Dialog open onOpenChange={onCancel}>
      <DialogContent className="max-w-2xl max-h-[80vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            {t('settings.permissions.confirmTitle')}
          </DialogTitle>
          <DialogDescription>
            {t('settings.permissions.confirmDescription', { count: changeCount })}
          </DialogDescription>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto pr-2">
          <div className="space-y-3">
            {Object.values(changes).map((change, idx) => (
              <div
                key={idx}
                className="rounded-lg border border-border bg-muted/50 p-3"
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="font-semibold text-sm text-foreground">
                      {t('settings.permissions.roles.' + change.role)} - {t('settings.permissions.fields.' + change.field_name)}
                    </div>
                    <div className="mt-1.5 flex items-center gap-4 text-sm">
                      <div className="flex items-center gap-1.5">
                        <span className="text-muted-foreground">{t('settings.permissions.viewLabel')}:</span>
                        {change.can_view ? (
                          <Check className="h-4 w-4 text-green-600" />
                        ) : (
                          <X className="h-4 w-4 text-red-600" />
                        )}
                      </div>
                      <div className="flex items-center gap-1.5">
                        <span className="text-muted-foreground">{t('settings.permissions.editLabel')}:</span>
                        {change.can_edit ? (
                          <Check className="h-4 w-4 text-green-600" />
                        ) : (
                          <X className="h-4 w-4 text-red-600" />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={onCancel}>
            {t('common.cancel')}
          </Button>
          <Button onClick={onConfirm}>
            {t('settings.permissions.confirmChanges')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
